import type { RouteConfig } from 'vue-router';

const PassThrough = () => import('@/views/PassThrough.vue');
const ContractNotesList = () => import('@/pages/customers/contract-notes/ContractNotesList.vue');

const contractNotesRoutes: Array<RouteConfig> = [
  {
    path: 'contract-notes-new/:group?',
    name: 'contract-notes-new',
    redirect: (to) => ({ path: `/v3/customers/contract-notes/${to.params.group ?? ''}` }),
  },
  {
    path: 'contract-note-new/:uuid?',
    name: 'contract-note-new',
    props: true,
    redirect: (to) => ({ path: `/v3/customers/contract-notes/contract-note/${to.params.uuid ?? ''}` }),
  },
  {
    path: 'templates/contract-notes-new',
    name: 'template-contract-notes-new',
    redirect: { path: '/v3/customers/templates/contract-notes' },
  },
  {
    path: 'templates/contract-note-new/:uuid?',
    name: 'template-contract-note-new',
    props: true,
    redirect: (to) => ({ path: `/v3/customers/templates/contract-notes/contract-note/${to.params.uuid ?? ''}` }),
  },
  {
    path: 'contract-notes',
    component: PassThrough,
    alias: ['contract_note'],
    children: [
      {
        path: ':group?',
        name: 'contract-notes-list',
        meta: {
          title: 'contract_notes',
        },
        component: ContractNotesList,
        beforeEnter(to, _, next) {
          if (!to.params.group) {
            next({ name: 'contract-notes-list', params: { group: 'open' } });
          } else {
            next();
          }
        },
      },
    ],
  },
];

export default contractNotesRoutes;
